/* Behaviour for the Benuvera PDP build. Plain JS. */
(function () {
  'use strict';
  function qs(r, s) { return r.querySelector(s); }
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  /* Generic slider: [data-slider] > .slider (track) + optional [data-prev] [data-next] [data-dots] */
  function initSlider(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = qs(root, '[data-track]'); if (!track) return;
    var prev = qs(root, '[data-prev]'), next = qs(root, '[data-next]'), dots = qs(root, '[data-dots]');
    var isRev = !!root.closest('.review-slider'); if (isRev && !root.dataset.autoplay) root.dataset.autoplay = '4';
    function slides() { return qsa(track, ':scope > *'); }
    function step() {
      var s = slides(); if (!s.length) return 1;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return s[0].getBoundingClientRect().width + gap;
    }
    function pages() { return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); }
    function build() {
      if (!dots) return;
      dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        (function (i) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); });
          dots.appendChild(b);
        })(i);
      }
    }
    function update() {
      var idx = Math.round(track.scrollLeft / step());
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots) qsa(dots, 'button').forEach(function (b, i) { b.setAttribute('aria-current', String(i === idx)); });
      if (isRev) { var sl = slides()[idx]; if (sl) track.style.height = sl.offsetHeight + 'px'; }
    }
    window.addEventListener('load', function () { update(); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { build(); update(); });
    build(); update();
    var auto = parseFloat(root.dataset.autoplay || '0');
    if (auto > 0) { var timer = setInterval(function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (track.scrollLeft >= max) { if (isRev) clearInterval(timer); else track.scrollTo({ left: 0, behavior: 'smooth' }); } else track.scrollBy({ left: step(), behavior: 'smooth' });
    }, auto * 1000); }
  }

  /* Product gallery: main track + thumbnail track */
  function initGallery(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var main = qs(root, '[data-main]'), thumbs = qsa(root, '[data-thumb]');
    var items = main ? qsa(main, ':scope > li') : [];
    function set(i) {
      thumbs.forEach(function (t, j) { if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      var tt = thumbs[i]; var tr = qs(root, '.thumbnail-list');
      if (tt && tr) { var li = tt.parentElement; tr.scrollTo({ left: Math.max(0, li.offsetLeft - tr.offsetLeft - 4), behavior: 'smooth' }); }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (items[i]) main.scrollTo({ left: items[i].offsetLeft - main.offsetLeft, behavior: 'smooth' });
        set(i);
      });
    });
    if (main) main.addEventListener('scroll', function () {
      var w = items[0] ? items[0].getBoundingClientRect().width : 1;
      set(Math.min(items.length - 1, Math.round(main.scrollLeft / w)));
    }, { passive: true });
    var mp = qs(root, '[data-main-prev]'), mn = qs(root, '[data-main-next]');
    function mstep() { return items[0] ? items[0].getBoundingClientRect().width : 1; }
    if (mp && main) mp.addEventListener('click', function () { main.scrollBy({ left: -mstep(), behavior: 'smooth' }); });
    if (mn && main) mn.addEventListener('click', function () { main.scrollBy({ left: mstep(), behavior: 'smooth' }); });
    if (main) main.addEventListener('scroll', function () {
      if (mp) mp.disabled = main.scrollLeft <= 2;
      if (mn) mn.disabled = main.scrollLeft >= main.scrollWidth - main.clientWidth - 2;
    }, { passive: true });
    var p = qs(root, '[data-thumb-prev]'), n = qs(root, '[data-thumb-next]'), tr2 = qs(root, '.thumbnail-list');
    if (p && tr2) p.addEventListener('click', function () { tr2.scrollBy({ left: -tr2.clientWidth * .6, behavior: 'smooth' }); });
    if (n && tr2) n.addEventListener('click', function () { tr2.scrollBy({ left: tr2.clientWidth * .6, behavior: 'smooth' }); });
    set(0);
  }

  /* Tabs */
  function initTabs(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var btns = qsa(root, '[data-tab-btn]'), panels = qsa(root, '[data-tab-panel]'), bg = qs(root, '[data-tab-bg]');
    function place(animate) {
      if (!bg) return;
      var a = btns.filter(function (b) { return b.classList.contains('content-tab-button--active'); })[0]; if (!a) return;
      bg.style.transitionDuration = animate ? '.4s' : '0s';
      bg.style.width = a.offsetWidth + 'px'; bg.style.height = a.offsetHeight + 'px'; bg.style.top = a.offsetTop + 'px'; bg.style.left = a.offsetLeft + 'px';
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x, j) { x.classList.toggle('content-tab-button--active', i === j); x.setAttribute('aria-selected', String(i === j)); });
        panels.forEach(function (p, j) { p.classList.toggle('content-tab--active', i === j); });
        place(true);
      });
    });
    place(false); window.addEventListener('resize', function () { place(false); }); window.addEventListener('load', function () { place(false); });
  }

  /* Steps timeline: progress fills as the list scrolls through the viewport */
  function initSteps(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var prog = qs(root, '[data-steps-progress]'), items = qsa(root, '[data-step]'), wrap = qs(root, '.steps__wrap');
    function upd() {
      var r = wrap.getBoundingClientRect(), vh = window.innerHeight, wide = window.innerWidth >= 1024;
      var p = Math.max(0, Math.min(1, (vh * .6 - r.top) / Math.max(1, r.height)));
      if (prog) prog.style.setProperty('--progress', (wide ? 100 : p * 100) + '%');
      items.forEach(function (it) { var b = it.getBoundingClientRect(); it.classList.toggle('is-reached', b.top < vh * .75); });
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* Bundle selector: picks the real variant (one-time or Subscribe) and the selling plan */
  function initBundles(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var bars = qsa(root, '[data-bundle]');
    var form = root.closest('form');
    var idIn = form ? qs(form, 'input[name="id"]') : null;
    var card = qs(root, '[data-sub-card]'), plan = qs(root, '[data-sub-plan]');
    var box = card ? qs(card, '[data-check]') : null;
    var sel = 0, sub = false;
    bars.forEach(function (b, i) { var r = qs(b, 'input[type=radio]'); if (r && r.checked) sel = i; });
    function sync() {
      var bar = bars[sel];
      root.classList.toggle('is-sub', sub);
      bars.forEach(function (b, i) { b.classList.toggle('kaching-bundles__bar--selected', i === sel); var r = qs(b, 'input[type=radio]'); if (r) r.checked = (i === sel); });
      if (idIn && bar) idIn.value = (sub && bar.dataset.variantSub) ? bar.dataset.variantSub : bar.dataset.variantOt;
      if (plan) plan.disabled = !sub;
      if (box) { box.classList.toggle('is-checked', sub); box.setAttribute('aria-checked', String(sub)); }
    }
    bars.forEach(function (b, i) { b.addEventListener('click', function () { sel = i; sync(); }); });
    if (card) {
      card.addEventListener('click', function (e) { if (e.target.closest('select')) return; sub = !sub; sync(); });
      if (box) box.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); sub = !sub; sync(); } });
    }
    qsa(root, '[data-addon-card]').forEach(function (c) {
      var k = qs(c, '[data-check]'); if (k) c.addEventListener('click', function () { k.classList.toggle('is-checked'); });
    });
    sync();
  }

  /* Ingredients list */
  function initIngredients(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var rows = qsa(root, '[data-ing-row]'), details = qsa(root, '[data-ing-detail]');
    rows.forEach(function (r, i) {
      r.addEventListener('click', function () {
        rows.forEach(function (x, j) { x.classList.toggle('is-active', i === j); });
        details.forEach(function (d, j) { d.hidden = i !== j; });
      });
    });
  }

  /* Scroll to top */
  function initTop() {
    var b = qs(document, '[data-scroll-top]'); if (!b || b.dataset.ready) return; b.dataset.ready = '1';
    function t() { b.style.opacity = window.scrollY > 600 ? '1' : '0'; b.style.pointerEvents = window.scrollY > 600 ? 'auto' : 'none'; }
    window.addEventListener('scroll', t, { passive: true }); t();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* Dynamic shipping dates */
  function initDates(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function ord(n) { var s = ['th','st','nd','rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
    function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
    function fmt(d) { return M[d.getMonth()] + ' ' + ord(d.getDate()); }
    qsa(root, '[data-date]').forEach(function (el) {
      var parts = el.dataset.date.split('-').map(Number), now = new Date();
      var a = addBiz(now, parts[0]);
      el.textContent = parts.length > 1 ? fmt(a) + ' - ' + fmt(addBiz(now, parts[1])) : fmt(a);
    });
  }

  /* Scroll-in reveal (replaces the reference's animate-section behaviour) */
  var io;
  function initReveal(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.classList.add('sh-js');
    if (!io) io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('sh-in'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    var secs = qsa(scope === document ? document : scope, '#MainContent .shopify-section');
    if (scope !== document && scope.matches && scope.matches('#MainContent .shopify-section')) secs.push(scope);
    secs.forEach(function (sec, i) {
      if (sec.dataset.rv || (scope === document && i === 0)) return; sec.dataset.rv = '1';
      sec.classList.add('sh-reveal');
      qsa(sec, '.sl__item, .accordion, .stat, .step, [data-reveal-item]').forEach(function (c, j) { c.style.setProperty('--rv-d', Math.min(j, 6) * 80 + 'ms'); c.classList.add('sh-reveal-item'); });
      io.observe(sec);
    });
  }

  /* Cart drawer: opens on cart icon / add to cart, re-renders through the Section Rendering API */
  var CD_SEC = 'sh-cart-drawer';
  function cdEl() { return qs(document, '[data-cd]'); }
  var cdTick = null;
  function cdTimer() {
    var cd = cdEl(), out = cd && qs(cd, '[data-cd-time]'); if (cdTick) { clearInterval(cdTick); cdTick = null; }
    if (!out) return;
    var mins = parseInt(cd.dataset.timer, 10) || 10, key = 'sh_cart_end', end = 0;
    try { end = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    function t() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000)), m = Math.floor(left / 60), s = left % 60;
      out.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (!left) { clearInterval(cdTick); try { sessionStorage.removeItem(key); } catch (e) {} }
    }
    t(); cdTick = setInterval(t, 1000);
  }
  function cdOpen() { var cd = cdEl(); if (!cd) return; cd.classList.add('is-open'); cd.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function cdClose() { var cd = cdEl(); if (!cd) return; cd.classList.remove('is-open'); cd.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function cdBubble(count) {
    qsa(document, '.header__icon--cart').forEach(function (a) {
      var b = qs(a, '.cart-count-bubble');
      if (!count) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true"></span>'; a.appendChild(b); }
      qs(b, 'span').textContent = count;
    });
  }
  function cdRefresh(open) {
    var cd = cdEl(); if (!cd) return Promise.resolve();
    return fetch('/?sections=' + CD_SEC + '&_=' + Date.now()).then(function (r) { return r.json(); }).then(function (j) {
      var html = j[CD_SEC]; if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = qs(tmp, '[data-cd]'); if (!fresh) return;
      var was = cd.classList.contains('is-open');
      cd.innerHTML = fresh.innerHTML; cd.dataset.upIds = fresh.dataset.upIds;
      cd.classList.remove('is-busy');
      if (was || open) cdOpen();
      cdTimer();
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cdBubble(c.item_count); });
    });
  }
  function cdPost(url, body) {
    var cd = cdEl(); if (cd) cd.classList.add('is-busy');
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function initCart() {
    if (document.documentElement.dataset.cdReady) return; document.documentElement.dataset.cdReady = '1';
    document.addEventListener('click', function (e) {
      var cart = e.target.closest('.header__icon--cart');
      if (cart && cdEl()) { e.preventDefault(); cdRefresh(true); return; }
      if (e.target.closest('[data-cd-close]')) { cdClose(); return; }
      var ch = e.target.closest('[data-cd-change]');
      if (ch) { cdPost('/cart/change.js', { id: ch.dataset.cdChange, quantity: parseInt(ch.dataset.qty, 10) }).then(function () { return cdRefresh(); }); return; }
      var up = e.target.closest('[data-cd-up]');
      if (up) {
        var p = up.dataset.key ? cdPost('/cart/change.js', { id: up.dataset.key, quantity: 0 }) : cdPost('/cart/add.js', { items: [{ id: parseInt(up.dataset.variant, 10), quantity: 1 }] });
        p.then(function () { return cdRefresh(); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cdClose();
      if ((e.key === ' ' || e.key === 'Enter') && e.target.matches && e.target.matches('[data-cd-up]')) { e.preventDefault(); e.target.click(); }
    });
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('form[action*="/cart/add"]') || !cdEl()) return;
      e.preventDefault();
      var btn = qs(f, '[type=submit]'); if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
        .then(function (r) { return r.json(); })
        .then(function () { return cdRefresh(true); })
        .catch(function () { f.submit(); })
        .then(function () { if (btn) btn.disabled = false; });
    });
    cdTimer();
  }

  function initAll(scope) {
    var r = scope || document;
    qsa(r, '[data-slider]').forEach(initSlider);
    qsa(r, '[data-gallery]').forEach(initGallery);
    qsa(r, '[data-tabs]').forEach(initTabs);
    qsa(r, '[data-steps]').forEach(initSteps);
    qsa(r, '[data-bundles]').forEach(initBundles);
    qsa(r, '[data-ingredients]').forEach(initIngredients);
    qsa(r, '[data-dates]').forEach(initDates);
    initTop();
    initCart();
    initReveal(r);
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
